import { render } from "./AprobariPortalHR.vue?vue&type=template&id=709c2962&ts=true"
import script from "./AprobariPortalHR.vue?vue&type=script&lang=ts"
export * from "./AprobariPortalHR.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__